import styled from "styled-components";

export const LiContainer = styled.li`
  padding: 1em;
  display: flex;
  flex-direction: row;
  justify-content: ${({ alignment }) => alignment || "center"};
  flex: 1;
  align-items: center;

  > * {
    text-decoration: none;
    font-size: 0.875em;
    font-family: Montserrat, Helvetica, Arial, sans-serif;
    line-height: 1.5em;
    font-weight: 400;
    color: #696057;
  }

  i {
    ${({ icon_style }) =>
      icon_style
        ? icon_style
        : `
    width: 17px;
    height: 17px;
  `}
  }

  .link {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    margin-left: 8px;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      color: #ff6000;
    }
  }

  .undefined-icon {
    margin-left: 0;
  }
`;
